import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-primary-950 text-lg">
                <i className="ri-movie-2-line"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">秋霞电影网</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200 max-w-md">
              秋霞电影网致力于为广大影视爱好者提供丰富、更新及时的电影与电视剧浏览服务。
              清晰的分类与便捷的检索，帮你在海量资源里快速找到想看的那一部。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold mb-4">快速导航</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/movie" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">电影分类</Link></li>
              <li><Link to="/category/tv" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">电视剧分类</Link></li>
              <li><Link to="/list" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">全部影视</Link></li>
              <li><Link to="/about-us" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>feedback@qiuxia-demo.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-400"></i>
                <span>在线反馈（演示）</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                <span>每日 09:00 - 22:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© 2026 秋霞电影网 · 本站为前端演示项目，不提供真实播放与下载服务</p>
          <p>所有影视信息与图片均为演示示例，版权归原权利人所有</p>
        </div>
      </div>
    </footer>
  );
}